// As fontes padrão do PDF só têm os caracteres latinos (WinAnsi): o resto vira algo parecido.
const TROCA: Record<string, string> = { '→': '->', '←': '<-', '≥': '>=', '≤': '<=', '✓': 'v', '✔': 'v', '☐': '[ ]', '☑': '[x]', '·': '·' };
export function limparTexto(s: string) {
  return String(s ?? '').replace(/[→←≥≤✓✔☐☑]/g, c => TROCA[c] ?? '')
    .replace(/[^\x09\x0A\x0D\x20-\x7E\xA0-\xFF–—‘’“”•…€]/g, '');
}
